import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { DashboardsState } from './types';

export const getters: GetterTree<DashboardsState, RootState> = {
  //
};
